import { render, staticRenderFns } from "./CardTabbed.vue?vue&type=template&id=2586a05a&scoped=true&"
import script from "./CardTabbed.vue?vue&type=script&lang=ts&"
export * from "./CardTabbed.vue?vue&type=script&lang=ts&"
import style0 from "./CardTabbed.vue?vue&type=style&index=0&lang=css&"
import style1 from "./CardTabbed.vue?vue&type=style&index=1&id=2586a05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2586a05a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/ec2-user/buildAgent/work/1ca6ccddf1d626f9/resources/vue/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VTab } from 'vuetify/lib'
import { VTabItem } from 'vuetify/lib'
import { VTabs } from 'vuetify/lib'
import { VTabsItems } from 'vuetify/lib'
installComponents(component, {VCard,VCardText,VTab,VTabItem,VTabs,VTabsItems})
